export const getPasswordChecker = (pass) => {
    let passType = "";

    const poorRegExp = /[a-z]/;
    const weakRegExp = /(?=.*?[0-9])/;
    const strongRegExp = /(?=.*?[#?!@$%^&*-])/;
    // const whitespaceRegExp = /^$|\s+/;

    const poorPassword = poorRegExp.test(pass);
    const weakPassword = weakRegExp.test(pass);
    const strongPassword = strongRegExp.test(pass);
    // const whiteSpace = whitespaceRegExp.test(pass);

    if (poorPassword) {
        passType = "poor";
    }
    if (weakPassword) {
        passType = "weak";
    }
    if (strongPassword) {
        passType = "strong";
    }
    if (pass?.length <= 5 && 0 < pass?.length) {
        passType = "poor";
    }

    return passType;
};
